import { Subject } from "rxjs";

const LayoutSubject = new Subject();

export { LayoutSubject };



// WEBPACK FOOTER //
// ./src/shared/LayoutSubject.js